import { jsx as _jsx } from "react/jsx-runtime";
import useWindowSize from 'syf-component-library/ui/customHooks/useWindowWidth';
import NoCertificatesFound from '../../../../../ui/templates/ErrorPage/NoCertificatesFound';
import CertificateHistoryList from '../../molecules/CertificateHistoryList';
import CertificateHistoryTable from '../../molecules/CertificateHistoryTable';
var CertificateHistory = function (_a) {
    var certificateDetails = _a.certificateDetails, mappedCertificates = _a.mappedCertificates, config = _a.config;
    var isLessThanDesktop = useWindowSize().isLessThanDesktop;
    if (!certificateDetails.length) {
        return _jsx(NoCertificatesFound, { config: config });
    }
    return isLessThanDesktop ? (_jsx(CertificateHistoryList, { certificates: certificateDetails })) : (_jsx(CertificateHistoryTable, { certificates: mappedCertificates }));
};
export default CertificateHistory;
